import "./styles.scss";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import Avatar from "../../../assets/images/profile/img_placeholder.svg";
import { setContract } from "../../../store/slices/b2b/b2bContracts.slice";

function ContactList({ readOnly, children }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contract } = useSelector((state) => state.b2bContractsReducer);

  const removeContact = async (e, findIndex) => {
    dispatch(
      setContract({
        ...contract,
        contractContacts: contract?.contractContacts.filter((value, index) => index !== findIndex),
      }),
    );
  };

  const contractContacts = contract?.contractContacts;

  return (
    <div className="lineInputs period">
      <label>{t("CONTACTS")}</label>
      <div className="lingos">
        <div className="lingoSelects">
          <div className="linha"></div>
          <div className="selects">
            <div className="delet">
              {contractContacts?.map((item, index) => {
                return (
                  <div key={index * 7}>
                    <div>
                      {t("CONTACT")} #{index + 1}
                      {!readOnly && (
                        <SCButtonAddInput
                          type="button"
                          name="remove"
                          style={{ marginLeft: "12px" }}
                          onClick={(e) => removeContact(e, index, item)}
                        >
                          {t("DELETE")} <i className="fa fa-times-circle-o" aria-hidden="true" />
                        </SCButtonAddInput>
                      )}
                    </div>

                    <div className="contacts">
                      <div className="results" style={{ width: "100%", border: "0" }}>
                        <div className="boxResults2 card" style={{ border: "0" }}>
                          {item && (
                            <img
                              alt="Avatar"
                              src={item?.contact?.user?.picture ? item?.contact?.user?.picture : Avatar}
                            />
                          )}
                          <div>
                            <h5>{decryptIfEncrypted(item?.contact ? item?.contact?.user?.name : item?.user?.name)}</h5>
                            <h5>
                              {decryptIfEncrypted(item?.contact ? item?.contact?.user?.email : item?.user?.email)}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactList;
